import React from 'react'
import AuditDataListfromApi from '../../components/AuditDataListfromApi'

export default function MatchDataSummery() {
  return (
      //    <div
      //   style={{
      //     borderRadius: '4px',
      //     background:'#42a1ad',
      //   }}
      // >
        <AuditDataListfromApi
        endpoint="/match"
        headerText="Matched Data Report"
      />
      // </div>
    
  )
}

 

 